import * as CustomeColors from "./colors";

export { CustomeColors };

